
export let objectAssignWithoutOverride = (target, ...sourceList) => {
  for (let source of sourceList) {
    if (!source) continue;
    for(let key of Object.keys(source)) {//this doesnt iterate over class like source properties
      if (!(key in target)) {//checks own and inherited keys, works fine also for class prototypes and instances
        const desc = Object.getOwnPropertyDescriptor(source, key);
        if (desc.enumerable) Object.defineProperty(target, key, desc);
      }
    }
  }
};

export let objectAssignWithOverride = (target, ...sourceList) => {
  for (let source of sourceList) {
    if (!source) continue;
    for(let key of Object.keys(source)) {//this doesnt iterate over class like source properties
      const desc = Object.getOwnPropertyDescriptor(source, key);
      if (desc.enumerable) Object.defineProperty(target, key, desc);
    }
  }
};



export let checkInstanceModifier = (target, ...sourceList) => {
  for (let source of sourceList) {
    if (!source) continue;
    for(let key of Object.keys(source)) {//this doesnt iterate over class like source properties
      const desc = Object.getOwnPropertyDescriptor(source, key);
      if (desc.enumerable) Object.defineProperty(target, key, desc);
    }
  }
};
